import settingsService from '../api';
import { 
  SET_SETTINGS, 
  SET_SYS_PROMPT,
  SET_USER_PROMPT,
  SET_ACCESS,
  SET_MAX_KEYS, 
  SET_PRODUCT, 
  SET_PLUGIN_INFO 
} from './settings.constants';


export const getSettingsTC = () => {
  return async (dispatch) => {
    try {
      const resp = await settingsService.getSettings();

      if (!resp?.data) {
        return;
      }

      const { systemPrompt, userPrompt, access } = resp.data

      const defaultAccess = {
        "pm-t1-shutt": true,
        "pm-t1-adobe": false,
        "pm-t1-canva": false,
        "pm-t2-shutt": true,
        "pm-t2-adobe": false,
        "pm-t2-canva": true,
        "pm-t3-shutt": false,
        "pm-t3-adobe": false,
        "pm-t3-canva": false,
        "kh-t1-shutt": true,
        "kh-t1-adobe": false,
        "kh-t1-canva": true,
        "kh-t2-shutt": true,
        "kh-t2-adobe": false,
        "kh-t2-canva": true,
        "admin-shutt": true,
        "admin-adobe": true,
        "admin-canva": true,
        "user-shutt": false,
        "user-adobe": false,
        "user-canva": false,
        "myteamart-shutt": true,
        "myteamart-adobe": true,
        "myteamart-canva": true,
        "adobe-shutt": true,
        "adobe-adobe": true,
        "adobe-canva": false,
      };

      const rebuildAccess = (obj) => {
        // Если obj — не объект, возвращаем defaultAccess
        if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
          console.log('repairAccess: input is not a valid object, returning defaults');
          return { ...defaultAccess };
        }

        const repaired = {};

        // Проходим по всем ключам из defaultAccess
        for (const key in defaultAccess) {
          // Проверяем, есть ли такое поле в obj и имеет ли оно корректный тип
          if (key in obj) {
            // Приводим значение к boolean
            //repaired[key] = Boolean(obj[key]);
          } else {
            // Если поля нет — используем дефолт
            repaired[key] = defaultAccess[key];
          }
        }

        // Объект "отремонтирован" — возвращаем
        return repaired;
      }
      const validAccess = rebuildAccess(access);

      dispatch(setSettingsAC(resp.data));
      dispatch(setAccessAC(validAccess));
      dispatch(setSysPromptAC(systemPrompt));
      dispatch(setUserPromptAC(userPrompt));
    } catch (error) {
      console.log(error);
    }
  };
};

export const setSettingsTC = () => {
  return async (dispatch, getState) => {
    try {
      const settingsData = getState()?.settingsData;
      const {systemPrompt, userPrompt, access} = settingsData;
      const allSettings = {systemPrompt, userPrompt, access };

      await settingsService.setSettings(allSettings);
    } catch (error) {
      console.log(error);
    }
  }
}

export const getMaxKeysTC = () => {
  return async (dispatch) => {
    try {
      const maxKeys = +localStorage.getItem("maxCopyKeys")

      if (!maxKeys) {
        return;
      }

      dispatch(setMaxKeysAC(maxKeys));
    } catch (error) {
      console.log(error);
    }
  };
};

/*export const getProductTC = (userId) => {
  return async (dispatch) => {
    try {
      //const resp = await settingsService.patreon()
      const resp = await settingsService.getProduct(userId);

      if (!resp?.data) {
        return;
      }

      //var wnd = window.open("about:blank", "", "_blank");
      //wnd.document.write(resp?.data);

      dispatch(setProductAC(resp.data));
    } catch (error) {
      console.log(error);
    }
  };
}*/

export const getPluginTC = (type) => {
  return async (dispatch) => {
    try {
      const data = await settingsService.getPlugin(type);

      if(data?.status === 200) {
        const blob = new Blob([data.data], {
          type: 'application/zip',
        });

        return blob;
      }

      throw new Error("The server did not return a result");
    } catch (error) {
      console.log(error);
      alert('Error download file.', error)
    }
  }
}

export const getPluginInfoTC = () => {
  return async (dispatch) => {
    try {
      const resp = await settingsService.getPluginInfo();
      
      dispatch(setPluginInfoAC(resp?.data));
    } catch (error) {
      console.log(error);
    }
  }
}

//ACTIONS
export const setSettingsAC = (payload) => {
  return {
    type: SET_SETTINGS,
    payload,
  };
};

export const setSysPromptAC = (payload) => {
  return {
    type: SET_SYS_PROMPT,
    payload,
  };
};

export const setUserPromptAC = (payload) => {
  return {
    type: SET_USER_PROMPT,
    payload,
  };
};

export const setAccessAC = (payload) => {
  return {
    type: SET_ACCESS,
    payload,
  };
};

export const setMaxKeysAC = (payload) => {
  return {
    type: SET_MAX_KEYS,
    payload,
  };
};

export const setProductAC = (payload) => {
  return {
    type: SET_PRODUCT,
    payload,
  };
};

export const setPluginInfoAC = (payload) => {
  return {
    type: SET_PLUGIN_INFO,
    payload,
  };
};
